import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class MarketplaceExtensionViewedTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Extension Viewed';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.MARKETPLACE.EXTENSION_VIEWED, ($e, data) => {
            this.trackSegment(data, true);
        });
    }
}
